const generateSrcset = (image, widths = []) => {
  const imageUrl = new URL(image["src"]);
  return widths.filter((width) => width <= image["width"]).map((width) => {
    imageUrl.searchParams.set("width", width.toString());
    return `${imageUrl.href} ${width}w`;
  }).join(", ");
}

const createImageElement = (image, classes, sizes, productTitle) => {
  const previewImage = image["preview_image"];
  const newImage = new Image(previewImage["width"], previewImage["height"]);
  newImage.className = classes;
  newImage.alt = image["alt"] || productTitle;
  newImage.sizes = sizes;
  newImage.src = previewImage["src"];
  newImage.srcset = generateSrcset(previewImage, [165, 360, 533, 720]);
  newImage.loading = "lazy"
  return newImage;
}

function checkSwatches(wrapperScope = document) {
  wrapperScope.querySelectorAll('.js-color-swatches-wrapper').forEach(wrapper => {
    // ✅ Prevent double binding per wrapper
    if (wrapper.dataset.swatchesBound) return;
    wrapper.dataset.swatchesBound = 'true';

    wrapper.addEventListener('click', (event) => {
      const input = event.target.closest('.js-color-swatches input');
      if (!input) return;

      const primaryImage = wrapper.querySelector(".media--first");
      if (!input.checked || !primaryImage) return;

      const secondaryImage = wrapper.querySelector(".media--second");
      const handleProduct = wrapper.dataset.product;


      // update link and add-to-cart
      const addBtn = wrapper.querySelector('.card__add-to-cart button[name="add"]');
      wrapper.querySelector('.js-color-swatches-link').setAttribute('href', input.dataset.variantLink);
      if (addBtn) {
        addBtn.setAttribute('aria-disabled', false);
        addBtn.querySelector('> span').classList.remove('hidden');
        addBtn.querySelector('.sold-out-message').classList.add('hidden');
        wrapper.querySelector('.card__add-to-cart input[name="id"]').value = input.dataset.variantId;
      }

      const currentColor = input.value;

      // fetch variant and replace image
      jQuery.getJSON(window.Shopify.routes.root + `products/${handleProduct}.js`, function (product) {
        const variant = product.variants.filter(item => item.featured_media != null && item.options.includes(currentColor))[0];
        if (!variant) return;

        const newPrimaryImage = createImageElement(variant.featured_media, primaryImage.className, primaryImage.sizes, product.title);
        // const wishlistBtn = wrapper.querySelector('.swym-button.swym-loaded');

        // if (wishlistBtn && input.dataset.variantId) {
        //   wishlistBtn.setAttribute('data-variant-id', input.dataset.variantId);
        // }

        if (newPrimaryImage.src !== primaryImage.src) {
          let flag = false;
          if (secondaryImage) {
            const secondaryPath = new URL(secondaryImage.src).pathname;
            const newPath = new URL(newPrimaryImage.src).pathname;
            if (secondaryPath === newPath) {
              primaryImage.remove();
              secondaryImage.classList.remove('media--second');
              secondaryImage.classList.add('media--first');
              flag = true;
            }
          }
          if (!flag) {
            primaryImage.animate({ opacity: [1, 0] }, { duration: 200, fill: 'forwards' });
            setTimeout(() => {
              primaryImage.replaceWith(newPrimaryImage);
              newPrimaryImage.animate({ opacity: [0, 1] }, { duration: 200 });
              if (secondaryImage) secondaryImage.remove();

              document.dispatchEvent(new
                CustomEvent("swym:collections-loaded"));
            }, 200);
          }
        }
      });
    });
  });
}


function colorSwatches() {
  checkSwatches();

  document.addEventListener('shopify:section:load', function () {
    checkSwatches();
  });
}

(function () {
  colorSwatches();
})()
